export default {
  "facet": {
    "type": [
      {
        "id": "videos",
        "display_name": "Videos"
      },
      {
        "id": "catalog",
        "display_name": "Kataloge & Broshüren"
      },
      {
        "id": "tec_info",
        "display_name": "Technical Information"
      },
      {
        "id": "installation",
        "display_name": "Installation Instruction"
      },
      {
        "id": "planning",
        "display_name": "Planning Document"
      },
      {
        "id": "order_forms",
        "display_name": "Order Form"
      },
      {
        "id": "maintenance",
        "display_name": "Wartung, Bedienung, Pflege"
      },
      {
        "id": "drawings",
        "display_name": "Technical Drawing"
      },
      {
        "id": "software",
        "display_name": "Software"
      },
      {
        "id": "certificate",
        "display_name": "Certificate"
      },
      {
        "id": "press",
        "display_name": "Presse & Marketing"
      }
    ]
  },
  "services": [
    {
      id: "downloads",
      display_name: "Downloads",
      image: "/siauv4/bootstrap/assets/img/icon_file.svg"
    }
    ,
    {
      id: "videos",
      display_name: "Videos",
      image: "/siauv4/bootstrap/assets/img/icon_play.svg"
    },
    {
        id: "faq",
        display_name: "FAQ",
        image: "/siauv4/bootstrap/assets/img/icon_faq.svg"
    }
  ],
  "categoryTree": [
    {
      id: "0",
      name: "window-systems",
      display_name: "Fenstersysteme",
      image: "http://www.siegenia.test/siauv4/media/roomcomfort/safety-sliding-door/kfvkeyless/sm_komfort_keyless_head.jpg",
      path: '/window-systems',
      status: 1,
      children: [
        {
          id: "2",
          name: "wood",
          display_name: "Beschläge für Holz",
          path: '/window-systems/wood',
          status: 1,
          children: [
            {
              id: "3",
              name: "titan-af",
              display_name: "TITAN AF",
              path: '/window-systems/wood/titan-af',
              status: 1
            },
            {
              id: "4",
              name: "titan-ip",
              display_name: "TITAN IP",
              path: '/window-systems/wood/titan-ip',
              status: 1
            },
            {
              id: "5",
              name: "favorit",
              display_name: "Favorit",
              path: '/window-systems/wood/favorit',
              status: 1
            }
            ,
            {
              id: "6",
              name: "a300",
              display_name: "A300",
              path: '/window-systems/wood/a300',
              status: 0
            }
          ]
        },
        {
          id: "7",
          name: "plastic",
          display_name: "Beschläge für Kunststoff",
          status: 1,
          path: '/window-systems/plastic',
          children: [
            {
              id: "8",
              name: "titan-ip",
              display_name: "TITAN IP",
              path: '/window-systems/plastic/titan-ip',
              status: 1
            },
            {
              id: "9",
              name: "favorit",
              display_name: "Favorit",
              path: '/window-systems/plastic/favorit',
              status: 1
            }
          ]
        },
        {
          id: "10",
          name: "alu",
          display_name: "Beschläge für Aluminium",
          path: '/window-systems/alu',
          status: 1
        }
      ],
    },
    {
      id: "11",
      name: "door-systems",
      display_name: "Türsysteme",
      path: '/door-systems',
      image: "http://www.siegenia.test/siauv4/media/products/comfort-systems/sm_komfortsysteme_head.jpg"
    },
    {
      id: "12",
      name: "comfort-systems",
      display_name: "Komfortsysteme",
      path: '/comfort-systems',
      image: "http://www.siegenia.test/siauv4/media/products/window-systems/sm_fenstersysteme_head.jpg"
    },
    {
      id: "13",
      name: "comfort-systems2",
      display_name: "Unternehmen",
      path: '/comfort-systems',
      image: "http://www.siegenia.test/siauv4/media/products/window-systems/sm_fenstersysteme_head.jpg"
    }

  ],
  "results": [
    {
      "type": "press",
      "data": {
        "keywords": [],
        "level_2": [165518, 165518, 165518, 165510, 165510, 165514, 165514, 165514, 165514],
        "level_0": [165487, 165487, 165487, 165487, 165487, 165487, 165487, 165487, 165487, 165487, 165487],
        "title": "Ausschreibungstext DRIVE",
        "level_1": [165488, 165488, 165488, 165488, 165488, 165488, 165488, 165488, 165488, 165488],
        "description": "Sammlung",
        "level_3": [165519, 165520, 165513, 165516, 165515, 165517],
        "existing_languages": ["de"],
        "url": "https:\/\/downloads.siegenia.com\/siauv3_micro_download_portal\/media\/gebaude\/drive.zip",
        "version": null,
        "size": 2048,
        "mime_type": "PDF",
        "id": "169286_de",
        "type_id": "planning",
        "alias": "Sammlung",
        "language": "de"
      }
    },
    {
      "type": "press",
      "data": {
        "keywords": [],
        "level_2": [165518, 165518, 165518, 165510, 165510, 165514, 165514, 165514, 165514],
        "level_0": [165487, 165487, 165487, 165487, 165487, 165487, 165487, 165487, 165487, 165487, 165487],
        "title": "Ausschreibungstext DRIVE Dummy",
        "level_1": [165488, 165488, 165488, 165488, 165488, 165488, 165488, 165488, 165488, 165488],
        "description": "Sammlung",
        "level_3": [165519, 165520, 165513, 165516, 165515, 165517],
        "existing_languages": ["de"],
        "url": "https:\/\/downloads.siegenia.com\/siauv3_micro_download_portal\/media\/gebaude\/drive.zip",
        "preview_url": "https:\/\/downloads.siegenia.com\/siauv3_micro_download_portal\/media\/gebaude\/drive.zip",
        "version": null,
        "size": 1024,
        "mime_type": "ZIP",
        "id": "169286_de",
        "type_id": "planning",
        "alias": "Sammlung",
        "language": "de"
      }
    },
    {
      "type": "video",
      "data": {
        "keywords": [],
        "level_2": [165518, 165518, 165518, 165510, 165510, 165514, 165514, 165514, 165514],
        "level_0": [165487, 165487, 165487, 165487, 165487, 165487, 165487, 165487, 165487, 165487, 165487],
        "title": "Video DRIVE",
        "level_1": [165488, 165488, 165488, 165488, 165488, 165488, 165488, 165488, 165488, 165488],
        "description": "Sammlung",
        "level_3": [165519, 165520, 165513, 165516, 165515, 165517],
        "existing_languages": ["de"],
        "url": "https:\/\/downloads.siegenia.com\/siauv3_micro_download_portal\/media\/gebaude\/drive.zip",
        "version": null,
        "size": 0,
        "id": "169286_de",
        "type_id": "planning",
        "alias": "Sammlung",
        "language": "de"
      }
    }
  ]
};
